<div *ngIf="currentLang === 'ja'">
  <div class="manual-link">
    <a [href]="manualTopLink">使い方トップ</a> » 予約設問詳細（追加・編集）の説明
  </div>

  <div class="manual-main" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px">

    <mat-card appearance="outlined" class="manual-card">
      <mat-card-header>
        <mat-card-title><span>予約設問詳細（追加・編集）の説明</span></mat-card-title>
      </mat-card-header>

      <mat-card-content>
        <div class="manual-img">
          <img src="assets/img/manual/reservation-question-dialog.png" width="100%">
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/A.png"> 閉じるボタン
        </div>
        <div class="manual-explain">
          クリックすることでダイアログを閉じます。<br>
          その際、編集した内容は保存されません。
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/B.png"> ID
        </div>
        <div class="manual-explain">
          設問のIDを設定します。<br>
          既に登録済みのIDは設定できません。
          <span class="manual-explain-notes">※必須</span>
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/C.png"> 表示番号
        </div>
        <div class="manual-explain">
          表示番号を設定します。<br>
          設問一覧上で表示番号（昇順）で表示されます。
          <span class="manual-explain-notes">※必須</span>
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/D.png"> 設問タイプ
        </div>
        <div class="manual-explain">
          設問タイプを設定します。<br>
          設問タイプは以下の６種類から選択できます<br>
          ・string　文字列入力型（単一行）<br>
          ・text-area　文字列入力型（複数行）<br>
          ・number　数値入力型<br>
          ・select　セレクトボックス単一選択型<br>
          ・checkbox　チェックボックス複数選択型<br>
          ・radio　ラジオボタン単一選択型<br>
          <span class="manual-explain-notes">※必須</span>
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/E.png"> 設問
        </div>
        <div class="manual-explain">
          設問を設定します。<br>
          編集ボタンから<a [href]="qnameDialogLink">編集用ダイアログ</a>を開き設定します。<br>
          <span class="manual-explain-notes">※必須項目</span>
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/F.png"> 補足文章
        </div>
        <div class="manual-explain">
          補足文章を設定します。<br>
          編集ボタンから<a [href]="qcompDialogLink">編集用ダイアログ</a>を開き設定します。<br>
          <span class="manual-explain-notes">※必須項目</span>
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/G.png"> 選択肢
        </div>
        <div class="manual-explain">
          選択肢を設定します。<br>
          選択肢追加ボタンで選択肢を追加できます。<br>
          ・選択肢　編集ボタンから<a [href]="qitemDialogLink">編集用ダイアログ</a>を開き設定します。<span class="manual-explain-notes">※必須項目</span><br>
          ・値　選択肢の値を設定します。<span class="manual-explain-notes">※必須項目</span><br>
          ・削除　選択肢を削除します。
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/H.png"> 更新ボタン
        </div>
        <div class="manual-explain">
          クリックすることで編集内容が更新されます。
        </div>

      </mat-card-content>
    </mat-card>

  </div>
</div>
<div *ngIf="currentLang === 'en'">
  <div class="manual-link">
    <a [href]="manualTopLink">User Guide Top</a> » Explanation of Reservation Question Details (Add/Edit)
  </div>

  <div class="manual-main" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px">

    <mat-card appearance="outlined" class="manual-card">
      <mat-card-header>
        <mat-card-title><span>Explanation of Reservation Question Details (Add/Edit)</span></mat-card-title>
      </mat-card-header>

      <mat-card-content>
        <div class="manual-img">
          <img src="assets/img/manual/en_reservation-question-dialog.png" width="100%">
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/A.png"> Close Button
        </div>
        <div class="manual-explain">
          Click to close the dialog.<br>
          Any edited content will not be saved.
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/B.png"> ID
        </div>
        <div class="manual-explain">
          Set the question ID.<br>
          Already registered IDs cannot be set.
          <span class="manual-explain-notes">*Required</span>
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/C.png"> Display Number
        </div>
        <div class="manual-explain">
          Set the display number.<br>
          Displayed in ascending order of display number in the question list.
          <span class="manual-explain-notes">*Required</span>
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/D.png"> Question Type
        </div>
        <div class="manual-explain">
          Set the question type.<br>
          You can choose from the following 6 types:<br>
          • string - Text input type (single line)<br>
          • text-area - Text input type (multiple lines)<br>
          • number - Number input type<br>
          • select - Select box single selection type<br>
          • checkbox - Checkbox multiple selection type<br>
          • radio - Radio button single selection type<br>
          <span class="manual-explain-notes">*Required</span>
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/E.png"> Question
        </div>
        <div class="manual-explain">
          Set the question.<br>
          Open the <a [href]="qnameDialogLink">edit dialog</a> from the edit button to configure.<br>
          <span class="manual-explain-notes">*Required field</span>
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/F.png"> Supplementary Text
        </div>
        <div class="manual-explain">
          Set the supplementary text.<br>
          Open the <a [href]="qcompDialogLink">edit dialog</a> from the edit button to configure.<br>
          <span class="manual-explain-notes">*Required field</span>
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/G.png"> Options
        </div>
        <div class="manual-explain">
          Set the options.<br>
          You can add options with the add option button.<br>
          • Option - Open the <a [href]="qitemDialogLink">edit dialog</a> from the edit button to configure. <span class="manual-explain-notes">*Required field</span><br>
          • Value - Set the option value. <span class="manual-explain-notes">*Required field</span><br>
          • Delete - Delete the option.
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/H.png"> Update Button
        </div>
        <div class="manual-explain">
          Click to update the edited content.
        </div>

      </mat-card-content>
    </mat-card>

  </div>
</div>
